import { useState } from "react";
import {
  Box,
  Typography,
  Paper,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Grid,
} from "@mui/material";
import { styled, alpha } from "@mui/material/styles";
import { useEffect, useRef } from "react";

// ✅ Styled Card (same style as CourseCard)
const CategoryCard = styled(Paper)(({ theme, selected }) => ({
  padding: theme.spacing(2),
  borderRadius: "16px",
  backgroundColor: selected ? alpha("#30B0C7", 0.2) : alpha("#FFFFFF", 0.9),
  backdropFilter: "blur(8px)",
  boxShadow:
    "0px 1px 2px rgba(0, 0, 0, 0.3), 0px 1px 3px 1px rgba(0, 0, 0, 0.15)",
  cursor: "pointer",
  transition: "transform 0.3s ease, box-shadow 0.3s ease",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  minHeight: "90px",

  "&:hover": {
    transform: "translateY(-4px)",
    boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.15)",
  },
  ...(selected && {
    border: "2px solid #30B0C7",
  }),
}));

const StepOne = ({ onNext }) => {
  const topRef = useRef(null);

  const categories = [
    "Class 10th",
    "Class 12th",
    "Underpostgrad",
    "Underdoctarate",
    "Employed",
    "Unemployed",
    "Business/Entrepreneurship",
    "Retired",
    "Others",
  ];

  const [selected, setSelected] = useState("");
  const [openDialog, setOpenDialog] = useState(false);
  const [otherValue, setOtherValue] = useState("");

  const [workshopDone, setWorkshopDone] = useState(null); // true | false
  const [currentQuestion, setCurrentQuestion] = useState(0);

  const [selectedDomains, setSelectedDomains] = useState([]);
  const isSeniorClass = ["Class 10th", "Class 11th", "Class 12th"].includes(
    selected,
  );

  const handleSelect = (item) => {
    if (item === "Others") {
      setOpenDialog(true);
    } else {
      setSelected(item);
      setWorkshopDone(null);
      setCurrentQuestion(0);
    }
  };

  useEffect(() => {
    if (currentQuestion > 0) {
      topRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }, [currentQuestion]);

  useEffect(() => {
    if (selected) {
      topRef.current?.scrollIntoView({ behavior: "smooth" });
    }
  }, [selected]);

  const handleConfirmOthers = () => {
    if (!otherValue.trim()) return;
    setSelected(otherValue.trim());
    setOpenDialog(false);
  };

  const handleNextClick = () => {
    if (!selected) return;

    onNext({
      category: selected,
    });
  };
  const hideCategorySection =
    isSeniorClass && workshopDone === true && currentQuestion >= 1;

  return (
    <Box ref={topRef}>
      {!hideCategorySection && (
        <>
          <Typography
            sx={{ textAlign: "center", fontFamily: "Aclonica", py: 2 }}
            variant="h4"
            fontWeight={600}
            mb={3}
          >
            Select Category
          </Typography>

          <Grid container spacing={2}>
            {categories.map((item) => (
              <Grid item xs={12} sm={6} md={4} key={item}>
                <CategoryCard
                  selected={selected === item}
                  onClick={() => handleSelect(item)}
                >
                  <Typography fontSize="1rem" fontWeight={500}>
                    {item}
                  </Typography>
                </CategoryCard>
              </Grid>
            ))}
          </Grid>
        </>
      )}

      {/* {isSeniorClass && (
        <Box mt={10} backgroundColor="white" px={3} py={2} borderRadius={8}>
          <Typography
            fontSize={24}
            fontWeight={600}
            mb={2}
            textAlign={"center"}
          >
            Have you done YAPASSIO’s career decision workshop?
          </Typography>

          <Box display="flex" justifyContent="center" gap={2}>
            <Button
              variant={workshopDone === true ? "contained" : "outlined"}
              onClick={() => {
                setWorkshopDone(true);
                setCurrentQuestion(1);
              }}
            >
              Yes
            </Button>

            <Button
              variant={workshopDone === false ? "contained" : "outlined"}
              onClick={() => {
                setWorkshopDone(false);
                setCurrentQuestion(0);
              }}
            >
              No
            </Button>
          </Box>
        </Box>
      )}

      {isSeniorClass && workshopDone === true && (
        <Box mt={6} backgroundColor="white" p={3} borderRadius={8}>
          <WorkshopQuestions
            responses={responses}
            setResponses={setResponses}
            currentQuestion={currentQuestion}
            setCurrentQuestion={setCurrentQuestion}
          />
        </Box>
      )} */}

      <div style={{ display: "flex", justifyContent: "center" }}>
        <Button
          variant="contained"
          disabled={!selected}
          onClick={handleNextClick}
          sx={{
            mt: 4,
            backgroundColor: "#30B0C7",
            borderRadius: "100px",
            textTransform: "none",
            fontWeight: 600,
            "&:hover": { backgroundColor: "#2799AD" },
            width: "200px",
            p: 1,
            fontSize: "20px",
          }}
        >
          Next
        </Button>
      </div>
      {/* ✅ Others Dialog */}
      <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
        <DialogTitle>Enter your category</DialogTitle>
        <DialogContent>
          <TextField
            fullWidth
            autoFocus
            margin="dense"
            label="Your Category"
            value={otherValue}
            onChange={(e) => setOtherValue(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialog(false)}>Cancel</Button>
          <Button variant="contained" onClick={handleConfirmOthers}>
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default StepOne;
